import { render, staticRenderFns } from "./IntroWidget.vue?vue&type=template&id=3821bae1&scoped=true&"
import script from "./IntroWidget.vue?vue&type=script&lang=js&"
export * from "./IntroWidget.vue?vue&type=script&lang=js&"
import style0 from "./IntroWidget.vue?vue&type=style&index=0&id=3821bae1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821bae1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
